import Swiper from 'swiper';

class BlockSliderPosts {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-posts__swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      mousewheel: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    });
  }
}

export const blockSliderPosts = new BlockSliderPosts();
